import Crud from '../components/Shift/Crud.vue'
import Add from '../components/Shift/Add'
import Edit from '../components/Shift/Edit.vue'



let routes = {
    path: '/shifts',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/shifts',
            name: 'Turnos',
            component: Crud
        },
        {
            path: '/shifts/add',
            name: 'Novo Turno',
            component: Add
        },
        {
            path: '/shifts/edit/:id',
            name: 'Editar Turno',
            component: Edit
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/shift.js